import React from "react"
import { Formik, Form as FormikForm, Field } from "formik"
import { Row, Form } from "react-bootstrap"
import * as Yup from "yup"
import * as ErrorMessage from "../../common/errorMessage"
import * as Constants from "../../common/constants"
import * as Regex from "../../common/regex"
import * as Alert from "../../services/sweetalertService"

import FormTextbox from "../shared/formTextbox"
import FormFieldDisableAutoComplete from "../shared/formFieldDisableAutoComplete"
import FormDisabledTextBox from "../shared/FormDisabledTextBox"
import FormMobileTextBox from "../shared/formMobileTextBox"

import {
  updateValidFormData,
  updateFormIsValid,
  controlDeclaration,
  editAllInvalidForm,
  updateUiData,
  updateClickedNext,
} from "../../redux/actions"
import { useDispatch, batch } from "react-redux"

//import { useStaticQuery, graphql, navigate } from "gatsby"
//import { useDispatch } from "react-redux"
//import { updateClaimInfo } from "../../actions"

const ReviewClaim = ({ claimData, uiData }) => {
  const dispatch = useDispatch()
  const { pageNumber, clickedNext, hideHeaderFooter } = uiData

  const formRef = React.useRef()

  const policyInfoSchema = Yup.object().shape({
    claimantEmail: Yup.string()
      .required(ErrorMessage.claimantEmail)
      .email(ErrorMessage.claimantEmail),
    claimantMobile: Yup.string()
      .required(ErrorMessage.claimantMobile)
      .matches(Regex.mobilepattern, ErrorMessage.claimantMobile),
  })

  return (
    <Row className={pageNumber === Constants.reviewPageNumber ? "" : "hide"}>
      <div
        className={
          "title text-center " +
          (pageNumber === Constants.reviewPageNumber ? "" : "hide") +
          " " +
          (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
        }
      >
        Review and modify the claim information
      </div>
      <div className="marginTop1x borderBottomDottedGrey noPaddingLeftRightSmallScreen mb-4 bigScreenNarrowing width100">
        <div className="col-12 benefitsHeaderSummaryDiv">
          Claimant Information
        </div>
      </div>
      <Row className="col-xs-12 containerBody summaryContainerBody mb-4 blueBG">
        <Formik
          initialValues={Object.assign({}, claimData["claimPADetail"])}
          enableReinitialize={true}
          validationSchema={policyInfoSchema}
          validateOnMount={true}
          innerRef={formRef}
          onSubmit={(values, actions) => {}}
        >
          {({
            values,
            errors,
            touched,
            dirty,
            handleChange,
            handleBlur,
            handleSubmit,
            meta,
            props,
            isValid,
          }) => (
            <FormikForm
              id="summary"
              onSubmit={handleSubmit}
              className="formContainer offset-xs-0 col-xs-12 col-md-12"
            >
              {" "}
              <Form.Group>
                <Row className="form-group">
                  <div className="col-12 textforinput marginTop10px benefitEditTitle">
                    <p>Please review the claimant information</p>
                  </div>
                </Row>
              </Form.Group>
              {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
              <Field
                textDesc={"Disable Auto Complete"}
                name="disableAutoComplete"
                component={FormFieldDisableAutoComplete}
              />
              <Field
                textDesc={"Policy Number"}
                name="policyNumber"
                component={FormDisabledTextBox}
                toUpperCase={true}
              />
              <Field
                textDesc={"Policyholder’s name as per NRIC"}
                name="policyHolderName"
                component={FormDisabledTextBox}
                toUpperCase={true}
              />
              <Field
                textDesc={"Claimant Name as per NRIC"}
                name="claimantName"
                component={FormDisabledTextBox}
                toUpperCase={true}
              />
              <Field
                textDesc={"Claimant NRIC/FIN Number"}
                name="claimantNricNumber"
                component={FormDisabledTextBox}
                toUpperCase={true}
              />
              <Field
                textDesc={"Email ID"}
                maxLength={100}
                name="claimantEmail"
                component={FormTextbox}
                toUpperCase={false}
              />
              <Field
                textDesc={"Mobile number"}
                maxLength={9}
                name="claimantMobile"
                component={FormMobileTextBox}
                toUpperCase={false}
              />
              <HandleFormValidation
                reviewPageClickedNext={clickedNext[Constants.reviewPageNumber]}
                formRef={formRef}
                values={values}
                pageNumber={pageNumber}
                dispatch={dispatch}
                formName={Constants.reviewFormName}
              />
              <HandleFinalValidation
                reviewPageClickedNext={clickedNext[Constants.reviewPageNumber]}
                dispatch={dispatch}
                uiData={uiData}
                formIsValid={uiData.formIsValid}
              />
            </FormikForm>
          )}
        </Formik>
      </Row>
    </Row>
  )
}

const HandleFormValidation = ({
  reviewPageClickedNext,
  formRef,
  values,
  pageNumber,
  dispatch,
  formName,
}) => {
  React.useEffect(() => {
    if (reviewPageClickedNext) {
      formRef.current.validateForm().then(errors => {
        // console.log(errors)

        batch(() => {
          if (Object.entries(errors).length === 0) {
            // console.log("PASS")
            dispatch(updateValidFormData("claimPADetail", values))
            dispatch(updateFormIsValid(formName, true))

            // dispatch(pageIncrement())
            // dispatch(updateClickedNext(pageNumber, false))
          } else {
            // console.log("FAIl")
            // Alert.missingInfoAlert()
            formRef.current.submitForm() // Set touched to all fields
            dispatch(updateFormIsValid(formName, false))

            // dispatch(updateClickedNext(pageNumber, false))
          }
        })
      })
    }
  }, [formRef, values, pageNumber, dispatch, reviewPageClickedNext, formName])
  return null
}

const HandleFinalValidation = ({
  reviewPageClickedNext,
  dispatch,
  uiData,
  formIsValid,
}) => {
  const checkAllFormIsChecked = (formIsValid, chosenedBenefits) => {
    let result = true

    chosenedBenefits.forEach((item, key) => {
      if (!formIsValid.hasOwnProperty(item.CoverageCode)) {
        result = false
      }
    })
    if (!formIsValid.hasOwnProperty(Constants.reviewFormName)) {
      result = false
    }
    return result
  }

  const checkAllFormIsValid = (formIsValid, chosenedBenefits) => {
    let invalidForm = []

    chosenedBenefits.forEach((item, key) => {
      if (!formIsValid[item.CoverageCode]) {
        invalidForm.push(item.CoverageCode)
      }
    })
    if (!formIsValid[Constants.reviewFormName]) {
      invalidForm.push(Constants.reviewFormName)
    }

    return invalidForm
  }

  React.useEffect(() => {
    if (
      reviewPageClickedNext &&
      checkAllFormIsChecked(formIsValid, uiData.chosenedBenefits)
    ) {
      let invalidFormArray = checkAllFormIsValid(
        formIsValid,
        uiData.chosenedBenefits
      )
      batch(() => {
        if (invalidFormArray.length === 0) {
          dispatch(controlDeclaration())
        } else {
          dispatch(editAllInvalidForm(invalidFormArray))
          Alert.missingInfoAlert()
        }

        dispatch(updateClickedNext(Constants.reviewPageNumber, false))
      })
      dispatch(updateUiData("formIsValid", {}))

      // dispatch(controlLoading())
    }
  }, [reviewPageClickedNext, dispatch, uiData, formIsValid])
  return null
}
export default ReviewClaim
